import {AppLanguage} from 'platform/locale';

import {isNotNil} from 'ramda';

import {getSafely} from 'shared/web';

import {ValueWithUnit} from '../../../types/ValueWithUnit';
import {WARNING_TRESHOLD} from '../constants/constants';
import {getSeverityAndTextForPaintThickness} from './getSeverityAndTextForPaintThickness';

export function createPaintThicknessAttributes(
  paintDataArray: Array<[string, ValueWithUnit | null]>,
  language: AppLanguage
) {
  if (!paintDataArray) {
    return [];
  }

  return paintDataArray
    .map((row) => {
      const {text, severity} = getSeverityAndTextForPaintThickness(row[1], WARNING_TRESHOLD);

      const label = getSafely(row[1]?.label, language);

      if (!label) {
        return null;
      }

      return {
        label,
        flag: {
          text,
          severity,
        },
      };
    })
    .filter(isNotNil);
}
